export enum SortingType {
  Popular,
  Relevance,
  PublicationDate,
}
